export default "__VITE_ASSET__DnjeWf0x__"